/**
 * Shared POS VAT helpers — mirror api-node compute-vat.
 * FE owns tax payload; use correct formula when inclusive vs exclusive.
 */

export function roundMoney(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/**
 * @param base - Unit price (gross when inclusive)
 * @param rate - Percentage (e.g. 25)
 * @param inclusive - includeTaxInItemPrice / isInclusive from tax or override
 */
export function computePercentageTax(base: number, rate: number, inclusive: boolean): number {
  if (!base || !rate) return 0;
  const raw = inclusive ? (base * rate) / (100 + rate) : (base * rate) / 100;
  return roundMoney(raw);
}
